jQuery(document).ready(function() {
    if ($('.blog-content-container').length > 0) {
        blogHandler.init();
    }
});